import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";interface TooltipOptionProps {
  with_print?: boolean; // Optional, defaults to false
  with_refresh?: boolean; // Optional, defaults to false
  with_export?: boolean; // Optional, defaults to false
  setPrint?: (value: any) => void; // Function that takes a boolean argument
  setRefresh?: (value: any) => void; // Function that takes a boolean argument
  setExport?: (value: any) => void; // Function that takes a boolean argument
}

const TooltipOption: React.FC<TooltipOptionProps> = ({
  with_print = false,
  with_refresh = false,
  with_export = false,
  setPrint = () => {},
  setRefresh = () => {},
  setExport = () => {},
}) => {
  return (
    <>
      {with_refresh?<div className="pe-1 mb-2">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">Refresh</Tooltip>}
        >
          <Link to="#" className="btn btn-outline-light bg-white btn-icon me-1">
            <i className="ti ti-refresh" />
          </Link>
        </OverlayTrigger>
      </div>:null}
     {with_print? <div className="pe-1 mb-2">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">Print</Tooltip>}
        >
          <button
            type="button"
            className="btn btn-outline-light bg-white btn-icon me-1"
          >
            <i className="ti ti-printer" />
          </button>
        </OverlayTrigger>
      </div>:null}
      {with_export?<div className="dropdown me-2 mb-2">
        <Link
          to="#"
          className="dropdown-toggle btn btn-light fw-medium d-inline-flex align-items-center"
          data-bs-toggle="dropdown"
        >
          <i className="ti ti-file-export me-2" />
          Export
        </Link>
        <ul className="dropdown-menu  dropdown-menu-end p-3">
          <li>
            <Link to="#" className="dropdown-item rounded-1">
              <i className="ti ti-file-type-pdf me-1" />
              Export as PDF
            </Link>
          </li>
          <li>
            <Link to="#"
              onClick={setExport}
            className="dropdown-item rounded-1">
              <i className="ti ti-file-type-xls me-1" />
              Export as Excel{" "}
            </Link>
          </li>
        </ul>
      </div>:null}
    </>
  );
};

export default TooltipOption;
